import React from 'react';
import classNames from 'classnames';
import useMatchMedia from 'hooks/useMatchMedia';
import ShareableLinkDesktopNavigation from '../ShareableLinkDesktopNavigation';
import ShareableLinkMobileNavigation from '../ShareableLinkMobileNavigation';

import './ShareableLinkNavigation.styles.scss';

type ShareableLinkNavigationProps = {
  className?: string;
};

const ShareableLinkNavigation: React.FC<ShareableLinkNavigationProps> = (
  props,
) => {
  const { className } = props;

  const classes = classNames('shareable-link-navigation', className);

  const isPhablet = useMatchMedia('isPhablet');

  return (
    <nav className={classes}>
      {isPhablet ? (
        <ShareableLinkMobileNavigation />
      ) : (
        <ShareableLinkDesktopNavigation />
      )}
    </nav>
  );
};

export default ShareableLinkNavigation;
